// src/components/Footer.tsx

import React from "react";

const Footer = () => {
  return (
    <footer className="footer-container">
      <p>© {new Date().getFullYear()} Allisson Néo. Todos os direitos reservados.</p>
    </footer>
  );
};

export default Footer;
